import * as constants from './constants';
import checkStatus from '../../../utils/checkStatus';
import { get } from '../../../utils/http';
import R from 'ramda';

export function updateProps(payload) {
  return { type: constants.UPDATE_POST_PAGE_PROP, payload };
}

export const getPost = (postId) => (dispatch, getState) => {
  const userId = getState().user && getState().user.get('id') ? getState().user.get('id') : undefined;
  dispatch({ type: constants.GET_POST_STARTED });
  return get(`/proxy/post/${postId}`)
  .then(checkStatus)
  .then(res => res.json())
  .then(response => {
    if (response.error) return dispatch({ type: constants.GET_POST_FAILED, payload: response });
    return dispatch({ type: constants.GOT_POST, payload: R.merge(response, { didUserLike: R.contains(userId, response.userIdsOfLikes || []) }) });
  })
  .catch(err => {
    console.log(err.stack);
    dispatch({ type: constants.GET_POST_FAILED });
  });
};



// WEBPACK FOOTER //
// ./src/app/stores/newsfeed/postPage/actions.js